import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import GenericIconButton from '../GenericComponents/GenericIconButton';
import styles from './Menu.module.css';

type MenuProps = {
    mainY: number;
    setMainY: React.Dispatch<React.SetStateAction<number>>;
};

const Menu: React.FC<MenuProps> = ({ mainY, setMainY }) => {
    const topRef = useRef<HTMLDivElement | null>(null);
    const { t, i18n } = useTranslation();

    const showHomepage = () => {
        setMainY(-100);
    }

    return (
        <div className={styles.Menu}>
            <div className={styles.menucontainer}>
                <div className={styles.menuheader}>
                    <div className={styles.topLeftButton}>
                        <GenericIconButton
                            icon='light/times.svg'
                            hoverEnabled={true}
                            width='28px'
                            height='28px'
                            onClick={(e: any) => {
                                showHomepage()
                            }}
                        />
                    </div>
                    <div className={styles.accessibility}>
                        <a href="https://www.quaibranly.fr/fr/handicap-moteur" target="_blank" rel="noopener noreferrer">
                            <span className={styles.wheelchair}></span>
                        </a>
                        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap/handicap-visuel" target="_blank" rel="noopener noreferrer">
                            <span className={styles.visual}></span>
                        </a>
                        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap/handicap-auditif" target="_blank" rel="noopener noreferrer">
                            <span className={styles.hearing}></span>
                        </a>
                        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap/handicap-mental" target="_blank" rel="noopener noreferrer">
                            <span className={styles.culture}></span>
                        </a>
                        <a href="https://www.quaibranly.fr/fr/si-vous-etes/en-situation-de-handicap/public-lsf" target="_blank" rel="noopener noreferrer">
                            <span className={styles.lsf}></span>
                        </a>
                    </div>
                    <div className={styles.socials}>
                        <a href="https://www.facebook.com/museeduquaibranlyjacqueschirac" target="_blank" rel="noopener noreferrer">
                            <span className={styles.facebook}></span>
                        </a>
                        <a href="http://twitter.com/quaibranly" target="_blank" rel="noopener noreferrer">
                            <span className={styles.twitter}></span>
                        </a>
                        <a href="https://instagram.com/quaibranly" target="_blank" rel="noopener noreferrer">
                            <span className={styles.insta}></span>
                        </a>
                        <a href="https://linktr.ee/mediathequequaibranly" target="_blank" rel="noopener noreferrer">
                            <span className={styles.linktree}></span>
                        </a>
                    </div>

                </div>

                <div className={styles.menubody}>
                    <div className={styles.bodyitem}>
                        <span><a href="https://www.quaibranly.fr/fr/collections/toutes-les-collections/explorer-les-collections-1#c217656" data-smenu="2">{t("header_cultural_warnings")}</a></span>
                    </div>
                    <div className={styles.bodyitem}>
                        <span><a href="https://www.quaibranly.fr/fr/collections/toutes-les-collections/explorer-les-collections-1#c217657" data-smenu="3">{t("header_reusing_contents")}</a></span>
                    </div>
                    <div className={styles.bodyitem}>
                        <span className={styles.last}><a href="https://www.quaibranly.fr/fr/collections/toutes-les-collections/explorer-les-collections-1#c217655" data-smenu="4">{t("header_collections")}</a></span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Menu;
